module.exports = __webpack_public_path__ + "static/media/picto-white-slow.7ebcda80.png";